module.exports = __webpack_public_path__ + "static/media/laboratorio-banner.458eb5af.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/laboratorio-banner.png
// module id = 177
// module chunks = 0